import React from 'react';

/**
 * Bars Staggered icon — three horizontal bars with staggered alignment.
 * Based on Font Awesome Free v7.2.0 (https://fontawesome.com).
 */
export const BarsStaggeredIcon = React.forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  ({ className, ...props }, ref) => (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 640 640"
      fill="currentColor"
      className={className}
      {...props}
    >
      <path d="M64 160C64 142.3 78.3 128 96 128L480 128C497.7 128 512 142.3 512 160C512 177.7 497.7 192 480 192L96 192C78.3 192 64 177.7 64 160zM128 320C128 302.3 142.3 288 160 288L544 288C561.7 288 576 302.3 576 320C576 337.7 561.7 352 544 352L160 352C142.3 352 128 337.7 128 320zM512 480C512 497.7 497.7 512 480 512L96 512C78.3 512 64 497.7 64 480C64 462.3 78.3 448 96 448L480 448C497.7 448 512 462.3 512 480z" />
    </svg>
  ),
);

BarsStaggeredIcon.displayName = 'BarsStaggeredIcon';
